import { http } from 'shared/api';

export default class Event {
  static fetch(deduction) {
    return http.get(`deductions/${deduction.id}/deduction_events`);
  }
}